/* eslint-disable react-refresh/only-export-components */
import { forwardRef } from 'react';
import {
  CollaborativeRunnerProvider,
  CollaborativeRunnerInputSection,
  CollaborativeRunnerOutputSection,
} from './CollaborativeRunnerContext';

/**
 * Полный блок запуска (вход + кнопка + вывод) для использования в одном месте.
 * Для разнесённых блоков используйте CollaborativeRunnerProvider + InputSection + OutputSection.
 */
const CollaborativeRunner = forwardRef(function CollaborativeRunner({ code, ydoc }, ref) {
  return (
    <CollaborativeRunnerProvider code={code} ydoc={ydoc} runRef={ref}>
      <div className="collab-runner">
        <CollaborativeRunnerInputSection />
        <CollaborativeRunnerOutputSection />
      </div>
    </CollaborativeRunnerProvider>
  );
});

export default CollaborativeRunner;
export {
  CollaborativeRunnerProvider,
  CollaborativeRunnerInputSection,
  CollaborativeRunnerOutputSection,
  OutputBlockRunInfo,
  useRunnerContext,
  EditorInputFilesBadge,
  RunnerTaskAttachmentsSync,
  RunnerSessionTaskAttachmentsSync,
} from './CollaborativeRunnerContext';
